import { Listbox as HeadlessListbox } from "@headlessui/react";
import { mdiUnfoldMoreHorizontal } from "@mdi/js";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
import { Icon } from "../icon/Icon";
export const ListboxButton = ({ children, className, showChevron = true, ...props }) => (React.createElement(HeadlessListbox.Button, { className: joinClasses(["nxm-dropdown-button", className]), ...props },
    !!children && React.createElement("span", null, children),
    showChevron && (React.createElement(Icon, { className: "nxm-dropdown-button-icon", path: mdiUnfoldMoreHorizontal, size: "none" }))));
